import React from 'react';

const FormSection = ({ title, children, className = '' }) => {
    return (
        <>
            <div className="col-12">
                <h3 className={`text-white p-3 mb-3 border-round text-lg font-semibold ${className}`} style={{ backgroundColor: 'rgb(39, 58, 129)' }}>
                    {title}
                </h3>
            </div>
            {children}
        </>
    );
};

export default FormSection;
